/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionAdditionalForm } from './PalReauthSubmissionAdditionalForm';
import {
    PalReauthSubmissionAdditionalFormFromJSON,
    PalReauthSubmissionAdditionalFormFromJSONTyped,
    PalReauthSubmissionAdditionalFormToJSON,
    PalReauthSubmissionAdditionalFormToJSONTyped,
} from './PalReauthSubmissionAdditionalForm';

/**
 * 
 * @export
 * @interface CreatePalReauthAdditionalForm201Response
 */
export interface CreatePalReauthAdditionalForm201Response {
    /**
     * 
     */
    data?: PalReauthSubmissionAdditionalForm;
}

/**
 * Check if a given object implements the CreatePalReauthAdditionalForm201Response interface.
 */
export function instanceOfCreatePalReauthAdditionalForm201Response(value: object): value is CreatePalReauthAdditionalForm201Response {
    return true;
}

export function CreatePalReauthAdditionalForm201ResponseFromJSON(json: any): CreatePalReauthAdditionalForm201Response {
    return CreatePalReauthAdditionalForm201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthAdditionalForm201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthAdditionalForm201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionAdditionalFormFromJSON(json['data']),
    };
}

export function CreatePalReauthAdditionalForm201ResponseToJSON(json: any): CreatePalReauthAdditionalForm201Response {
    return CreatePalReauthAdditionalForm201ResponseToJSONTyped(json, false);
}

export function CreatePalReauthAdditionalForm201ResponseToJSONTyped(value?: CreatePalReauthAdditionalForm201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionAdditionalFormToJSON(value['data']),
    };
}

